export default {
  "pl": {
    "todo": {
      "actions": {
        "add": "Dodaj zadanie",
        "cancel": "Anuluj",
        "delete_todo": "Usuń zadanie",
        "edit": "Edytuj zadanie",
        "save": "Zapisz"
      },
      "attributes": {
        "active": "Aktywne",
        "assignee": "Osoba odpowiedzialna",
        "completed": "Ukończone",
        "description": "Opis",
        "due_date": "Termin ukończenia"
      },
      "labels": {
        "active": "aktywnych",
        "allDone": "Wszystkie zadania są ukończone!",
        "allTodos": "Wszystkie zadania",
        "completed": "zakończony",
        "filterTodos": "Filtruj zadania",
        "filters": "Filtry",
        "myTodos": "Moje zadania",
        "myTodosCount": "Moje zadania ({count})",
        "noActiveTodos": "Brak aktywnych zadań",
        "noActiveTodosDashboard": "Gratulacje, nie masz żadnych otwartych zadań!",
        "noCompletedYet": "Brak ukończonych zadań.",
        "noTodosCustomer": "Świetnie! Nie masz żadnych nieukończonych zadań.",
        "selectAProjectFirst": "Najpierw wybierz projekt",
        "showLess": "Pokaż mniej",
        "showOthers": "Pokaż inne | Pokaż inne ({count})"
      },
      "toasts": {
        "create": "Utworzono zadanie",
        "delete": "Usunięto zadanie",
        "update": "Zaktualizowano zadanie"
      },
      "validation": {
        "needDescription": "Należy podać opis"
      }
    }
  }
}
